/**
 * Волна E (docs/MIGRATION_ROUTER.md §5).
 * Было: <CacheDataRoute exact path='/bar-menu/:barId/:tableId/menu' withoutFooter withoutHeader>.
 * path в staticData — для consent-модалки Header (includes('/bar-menu/')).
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../../../../CacheDataRoute';
import BarMenuMenu from '@routes/BarMenu/stages/BarMenuMenu';

export const Route = createFileRoute('/bar-menu/$barId/$tableId/menu')({
  staticData: {
    layout: {
      path: '/bar-menu/:barId/:tableId/menu',
      withoutHeader: true,
      withoutFooter: true
    }
  },
  component: () => (
    <CacheDataRoute component={BarMenuMenu} path='/bar-menu/:barId/:tableId/menu' />
  )
});
